var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-reports-item"},[_c('div',{staticClass:"c-reports-item__body"},[_c('p',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('h1',[_vm._v(" $1,888 ")])]),_c('div',{staticClass:"c-reports-item__chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }